var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.04,14.01v34.38c0,2.59-2.1,4.69-4.69,4.69H8.48c-2.59,0-4.69-2.1-4.69-4.69V14.01 c0-2.59,2.1-4.69,4.69-4.69h46.88C57.94,9.32,60.04,11.42,60.04,14.01z M55.35,14.01H8.48v34.38h46.88V14.01z M13.17,41.82v-1.88 c0-3.11,2.94-5.63,6.56-5.63c1.11,0,1.75,0.78,4.38,0.78c2.55,0,3.32-0.78,4.38-0.78c3.62,0,6.56,2.52,6.56,5.63v1.88 c0,1.04-0.98,1.88-2.19,1.88h-17.5C14.14,43.69,13.17,42.85,13.17,41.82z M17.85,24.94c0-3.45,2.8-6.25,6.25-6.25 s6.25,2.8,6.25,6.25s-2.8,6.25-6.25,6.25S17.85,28.39,17.85,24.94z M38.17,24.16V22.6c0-0.43,0.35-0.78,0.78-0.78h10.94 c0.43,0,0.78,0.35,0.78,0.78v1.56c0,0.43-0.35,0.78-0.78,0.78H38.95C38.52,24.94,38.17,24.59,38.17,24.16z M38.17,30.41v-1.56 c0-0.43,0.35-0.78,0.78-0.78h10.94c0.43,0,0.78,0.35,0.78,0.78v1.56c0,0.43-0.35,0.78-0.78,0.78H38.95 C38.52,31.19,38.17,30.84,38.17,30.41z M38.17,36.66V35.1c0-0.43,0.35-0.78,0.78-0.78h10.94c0.43,0,0.78,0.35,0.78,0.78v1.56 c0,0.43-0.35,0.78-0.78,0.78H38.95C38.52,37.44,38.17,37.09,38.17,36.66z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyProfile);
export default __webpack_public_path__ + "static/media/my_profile.e82b76c89a1408b463ee4b80d47493a5.svg";
export { ForwardRef as ReactComponent };